import axios from '../axios'
import useAuth from './useAuth'

const useLogout = () =>{
    const {setAuth} = useAuth()

    const logout = async ()=>{
        setAuth({})
        try{
           
            const response = await axios('/logout', {
                withCredentials: true,
                
            }
            )
            // localStorage.setItem("isAuth", false) //false
        }catch(err){
            console.log(err)
        }
    }
    return logout
}

export default useLogout